import React, { useState, useEffect } from 'react';
import { useDispatch } from 'redux-react-hook';
import styled from 'styled-components';
import _isObject from 'lodash/isObject';
import Modal from 'styles/blocks/modal/eTriage';
import { getLastQuestion } from 'redux/actions/consultation/question';
import { setInternetReconnectedValidation } from 'redux/actions/session';

const AlertModalContent = styled(Modal.ModalContent)`
  background-color: red;
`;

const AlertConfirmButton = styled(Modal.ConfirmButton)`
  border: 2px solid white;
`;

export const ErrorETriageModal = ({ isClinicalReviewMode, error }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    // Stops timeout warning modal on initial render
    if (window.cancelTimer) {
      window.cancelTimer();
    }
  }, []);
  const [isConnectivityError] = useState(() => _isObject(error) && !error.status && !error.errorMessage && !error.errorCode);
  const [isTryingToReconnect, setIsTryingToReconnect] = useState(isConnectivityError);
  useEffect(() => {
    let killSession;
    if (!isClinicalReviewMode && !isTryingToReconnect) {
      killSession = setTimeout(() => window.location.assign('/killsession'), 15000);
    }
    if (isTryingToReconnect) {
      dispatch(setInternetReconnectedValidation());
    }
    return () => clearTimeout(killSession);
  }, [dispatch, isClinicalReviewMode, isTryingToReconnect]);
  useEffect(() => {
    let callGetLastQuestion = null;
    let stopTryingToReconnect = null;
    if (isTryingToReconnect) {
      callGetLastQuestion = setInterval(() => dispatch(getLastQuestion()), 1000);
      stopTryingToReconnect = setTimeout(() => {
        setIsTryingToReconnect(false);
        clearInterval(callGetLastQuestion);
      }, 8000);
    }
    return () => {
      clearInterval(callGetLastQuestion);
      clearTimeout(stopTryingToReconnect);
    };
  }, [isTryingToReconnect, dispatch]);

  if (isConnectivityError) {
    if (isTryingToReconnect) {
      return (
        <Modal.Overlay>
          <Modal.ModalContent>
            <Modal.HeaderText>There&apos;s a problem with the internet connection.</Modal.HeaderText>
            <Modal.Text>Please wait, we&apos;re trying to reconnect...</Modal.Text>
            <Modal.BubblePulseLoader />
          </Modal.ModalContent>
        </Modal.Overlay>
      );
    }
    return (
      <Modal.Overlay>
        <Modal.ModalContent>
          <Modal.HeaderText>We can&apos;t access the internet right now.</Modal.HeaderText>
          <Modal.Text>Please book in at reception.</Modal.Text>
          <Modal.ConfirmButton as="a" href="/killsession">Okay, I understand</Modal.ConfirmButton>
        </Modal.ModalContent>
      </Modal.Overlay>
    );
  }
  return (
    <Modal.Overlay>
      <AlertModalContent>
        <Modal.Header>Contact reception immediately.</Modal.Header>
        <Modal.Text>An error occurred when submitting your details.</Modal.Text>
        <AlertConfirmButton as="a" href="/killsession">Okay, I understand</AlertConfirmButton>
      </AlertModalContent>
    </Modal.Overlay>
  );
};
